export function convertToCents(value: number) {
  return Number((value * 100).toFixed(0));
}

export function convertToDollars(value: number) {
  return value / 100;
}
